import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getUsuarios, eliminarUsuario, editarUsuario, editPassword } from '../../../redux/actions/useractions';
import { clearErrors } from '../../../redux/actions/dataactions';

import { DataGrid, esES, GridToolbarQuickFilter } from '@mui/x-data-grid';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Tooltip,
  CircularProgress,
  Typography,
  Grid
} from '@mui/material';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import './TablaUsuarios.css';
import { Link } from 'react-router-dom';

import { FaArrowLeft, FaCheckCircle, FaTrashAlt, FaUserEdit, FaCheck, FaArrowCircleLeft } from 'react-icons/fa';
import CrearUsuario from './CrearUsuario';
import AgregarTecnico from './AgregarTecnico';

class TablaUsuarios extends Component {
  constructor() {
    super();
    this.state = {
      errors: {},
      aprobado: {},
      openData: false,
      openDelete: false,
      openEditPassword: false,
      nombre: '',
      email: '',
      handle: '',
      tipouser: '',
      ccnit: '',
      ciudad: '',
      direccion: '',
      telefono: ''
    };
  }

  componentDidMount() {
    console.log(this.props.clienteId);
    this.props.getUsuarios(this.props.clienteId);
  }

  static getDerivedStateFromProps(props) {
    const newState = {};
    if (props.UI.errors) newState.errors = props.UI.errors;
    if (props.UI.aprobado) newState.aprobado = props.UI.aprobado;
    return Object.keys(newState).length > 0 ? newState : null;
  }

  handleOpenData = (data) => {
    this.setState({
      openData: true,
      nombre: data.nombre,
      email: data.email,
      handle: data.handle,
      tipouser: data.tipouser,
      ccnit: data.ccnit,
      ciudad: data.ciudad,
      direccion: data.direccion,
      telefono: data.telefono
    });
  };

  handleCloseData = () => {
    if (this.state.aprobado.mensaje) {
      this.props.getUsuarios(this.props.clienteId);
    }
    this.setState({ openData: false, errors: {}, aprobado: {} });
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleClose = () => {
    this.props.clearErrors();
    this.setState({
      openData: false,
      openDelete: false,
      openEditPassword: false,
      errors: {},
      aprobado: {},
      nombre: '',
      email: '',
      handle: '',
      tipouser: '',
      ccnit: '',
      ciudad: '',
      direccion: '',
      telefono: ''
    });
  };

  handleCloseDelete = () => {
    if (this.state.aprobado.mensaje) {
      this.props.getUsuarios(this.props.clienteId);
    }
    this.setState({ openDelete: false, errors: {}, aprobado: {} });
  };

  handleOpenDelete = (data) => {
    this.setState({ openDelete: true, handle: data.handle });
  };

  handleConfirmDelete = () => {
    this.props.eliminarUsuario(this.state.handle, this.props.clienteId);
  };

  handleEditData = () => {
    const Data = {
      ciudad: this.state.ciudad,
      direccion: this.state.direccion,
      nombre: this.state.nombre,
      telefono: this.state.telefono,
      handle: this.state.handle
    };
    this.props.editarUsuario(Data, this.props.clienteId);
  };

  handleOpenEditCredentials = (email, handle) => {
    this.setState({
      openEditPassword: true,
      email: email,
      password: '',
      confirmpassword: '',
      handle: handle
    });
  };

  handleEditPassword = () => {
    const Data = {
      password: this.state.password,
      confirmpassword: this.state.confirmpassword,
      email: this.state.email
    };
    this.props.editPassword(Data);
  };

  render() {
    const { usuarios, loading } = this.props.user;
    const { errors, aprobado } = this.props.UI;

    const columns = [
      {
        field: 'acciones',
        headerName: 'Acciones',
        width: 120,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        renderCell: (params) => (
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Tooltip title="Ver Perfil">
              <IconButton size="small" onClick={() => this.handleOpenData(params.row)}>
                <AssignmentIndIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Editar las credenciales de acceso del usuario">
              <IconButton size="small" onClick={() => this.handleOpenEditCredentials(params.row.email, params.row.idUsuario)}>
                <EditIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Eliminar usuario">
              <IconButton size="small" onClick={() => this.handleOpenDelete(params.row)}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </Box>
        )
      },
      {
        field: 'imagenurl',
        headerName: 'Avatar',
        width: 80,
        renderCell: (params) => (
          <img src={params.row.imageUrl} alt="avatar" style={{ width: 40, borderRadius: '50%' }} />
        )
      },
      { field: 'idUsuario', headerName: 'ID', width: 100 },
      { field: 'nombre', headerName: 'Nombre', width: 180 },
      { field: 'tipouser', headerName: 'Tipo', width: 120 },
      { field: 'email', headerName: 'Email', width: 220 },
      { field: 'ciudad', headerName: 'Ciudad', width: 140 },
      { field: 'telefono', headerName: 'Teléfono', width: 140 }
    ];
    const rows = Array.isArray(usuarios)
      ? usuarios.map((row, index) => ({ id: row.idUsuario || index, ...row }))
      : [];

    const mostrarTabla = (!errors || typeof errors === 'object') && Array.isArray(usuarios) && usuarios.length > 0;
    const mapeousuarios = !loading ? (
      <Box sx={{ width: '100%', mt: 2 }}>
        {/* Sección de acciones: Crear usuario, Agregar técnico */}
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: 2 }}
        >
          <Grid item xs={12} sm={6}>
            <Box display="flex" justifyContent="center">
              <CrearUsuario clienteId={this.props.clienteId} />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Box display="flex" justifyContent="center">
              <AgregarTecnico clienteId={this.props.clienteId} />
            </Box>
          </Grid>
        </Grid>

        {/* Tabla de usuarios o Mensaje */}
        {mostrarTabla ? (
          <Box
            sx={{
              height: 500,
              padding: 2,
              width: '100%',
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: 'primary.main',
                color: 'white'
              }
            }}
          >
            <DataGrid
              rows={rows}
              columns={columns}
              localeText={esES.components.MuiDataGrid.defaultProps.localeText}
              components={{
                Toolbar: () => (
                  <Box p={1}>
                    <GridToolbarQuickFilter placeholder="Buscar..." />
                  </Box>
                )
              }}
            />
          </Box>
        ) : (
          <Typography variant="body1" sx={{ textAlign: 'center', mt: 4 }}>
            {typeof errors === 'string' ? errors : 'No hay usuarios registrados, agrega uno para empezar.'}
          </Typography>
        )}
      </Box>
    ) : (
      // Si está cargando
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );

    return (
      <div>
        {mapeousuarios}

        <Dialog open={this.state.openData} onClose={this.handleCloseData} fullWidth maxWidth="sm">
          <DialogTitle>
            <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#0468BF', textAlign: 'center' }}>
              Detalles del usuario
            </Typography>
          </DialogTitle>
          <DialogContent>
            {aprobado ? (
              <Box textAlign="center">
                <FaCheck color="#0468BF" size={40} />
                <Typography>¡Usuario Actualizado exitosamente!</Typography>
              </Box>
            ) : (
              <Grid container spacing={2}>
                <Grid item xs={12} mt={2}>
                  <TextField
                    required
                    type="text"
                    name="nombre"
                    id="nombre"
                    autoComplete="name"
                    label="Nombre de la persona"
                    value={this.state.nombre}
                    onChange={this.handleChange}
                    size="small"
                    fullWidth
                    helperText={this.state.errors.nombre}
                    error={Boolean(this.state.errors.nombre)}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    disabled
                    required
                    type="email"
                    name="email"
                    id="email"
                    label="Email"
                    autoComplete="email"
                    value={this.state.email}
                    onChange={this.handleChange}
                    size="small"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    disabled
                    required
                    type="text"
                    name="handle"
                    id="handle"
                    autoComplete="username"
                    label="Handle/nombre del usuario a crear"
                    value={this.state.handle}
                    onChange={this.handleChange}
                    size="small"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    disabled
                    required
                    type="number"
                    name="ccnit"
                    id="ccnit"
                    label="Cédula o NIT"
                    value={this.state.ccnit}
                    onChange={this.handleChange}
                    size="small"
                    fullWidth
                    helperText={this.state.errors.ccnit}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    type="text"
                    name="ciudad"
                    id="ciudad"
                    label="Ciudad"
                    value={this.state.ciudad}
                    onChange={this.handleChange}
                    size="small"
                    fullWidth
                    helperText={this.state.errors.ciudad}
                    error={Boolean(this.state.errors.ciudad)}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    type="text"
                    name="direccion"
                    id="direccion"
                    label="Dirección"
                    autoComplete="street-address"
                    value={this.state.direccion}
                    onChange={this.handleChange}
                    size="small"
                    fullWidth
                    helperText={this.state.errors.direccion}
                    error={Boolean(this.state.errors.direccion)}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    type="number"
                    name="telefono"
                    id="telefono"
                    autoComplete="tel"
                    label="Teléfono del usuario"
                    value={this.state.telefono}
                    onChange={this.handleChange}
                    size="small"
                    fullWidth
                    helperText={this.state.errors.telefono}
                    error={Boolean(this.state.errors.telefono)}
                  />
                </Grid>
              </Grid>
            )}
          </DialogContent>
          <DialogActions>
            <Tooltip title="Cerrar">
              <IconButton onClick={this.handleCloseData} size="small">
                <FaArrowLeft color="#D3D7DC" />
              </IconButton>
            </Tooltip>
            {this.props.UI.loading ? (
              <CircularProgress size={30} color="primary" />
            ) : aprobado ? (
              <Tooltip title="Continuar">
                <IconButton onClick={this.handleCloseData} size="small">
                  <FaCheckCircle color="#20B90C" />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="Actualizar información">
                <IconButton onClick={this.handleEditData} size="small">
                  <FaUserEdit color="#03178C" />
                </IconButton>
              </Tooltip>
            )}
          </DialogActions>
        </Dialog>

        <Dialog open={this.state.openDelete} onClose={this.handleClose} fullWidth maxWidth="sm">
          <DialogTitle>
            <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#0468BF', textAlign: 'center' }}>
              ¿Estás seguro de eliminar este usuario?
            </Typography>
          </DialogTitle>
          <DialogContent>
            {aprobado ? (
              <Box textAlign="center">
                <FaCheck color="#0468BF" size={40} />
                <Typography>¡Usuario eliminado exitosamente!</Typography>
              </Box>
            ) : (
              <Typography>
                Recuerda que al eliminar este usuario no vas a volver a poder acceder a él, sin embargo la información asociada se conservará.
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Tooltip title="Cerrar">
              <IconButton onClick={this.handleCloseDelete} size="small">
                <FaArrowLeft color="#D3D7DC" />
              </IconButton>
            </Tooltip>
            {this.props.UI.loading ? (
              <CircularProgress size={30} color="primary" />
            ) : aprobado ? (
              <Tooltip title="Continuar">
                <IconButton onClick={this.handleCloseDelete} size="small">
                  <FaCheckCircle color="#20B90C" />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="Confirmar">
                <IconButton onClick={this.handleConfirmDelete} size="small">
                  <FaTrashAlt />
                </IconButton>
              </Tooltip>
            )}
          </DialogActions>
        </Dialog>

        <Dialog open={this.state.openEditPassword} onClose={this.handleClose} fullWidth maxWidth="sm">
          <DialogTitle>
            <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#0468BF', textAlign: 'center' }}>
              Actualizar las credenciales del usuario: {this.state.handle}
            </Typography>
          </DialogTitle>
          <DialogContent>
            {aprobado ? (
              <Box textAlign="center">
                <FaCheck color="#0468BF" size={40} />
                <Typography>¡Contraseña actualizada exitosamente!</Typography>
              </Box>
            ) : (
              <Grid container spacing={2}>
                <Grid item xs={12} mt={2}>
                  <TextField
                    required
                    type="text"
                    name="password"
                    id="password"
                    autoComplete="new-password"
                    label="Nueva contraseña"
                    value={this.state.password}
                    onChange={this.handleChange}
                    size="small"
                    fullWidth
                    helperText={this.state.errors.password || this.state.errors.passwords}
                    error={Boolean(this.state.errors.password || this.state.errors.passwords)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    type="text"
                    name="confirmpassword"
                    id="confirmpassword"
                    autoComplete="new-password"
                    label="Confirmar contraseña"
                    value={this.state.confirmpassword}
                    onChange={this.handleChange}
                    size="small"
                    fullWidth
                    helperText={this.state.errors.confirmpassword || this.state.errors.passwords}
                    error={Boolean(this.state.errors.confirmpassword || this.state.errors.passwords)}
                  />
                </Grid>
              </Grid>
            )}
          </DialogContent>
          <DialogActions>
            <Tooltip title="Cerrar">
              <IconButton onClick={this.handleClose} size="small">
                <FaArrowLeft color="#D3D7DC" />
              </IconButton>
            </Tooltip>
            {this.props.UI.loading ? (
              <CircularProgress size={30} color="primary" />
            ) : aprobado ? (
              <Tooltip title="Continuar">
                <IconButton onClick={this.handleClose} size="small">
                  <FaCheckCircle color="#20B90C" />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="Actualizar Contraseña">
                <IconButton onClick={this.handleEditPassword} size="small">
                  <FaUserEdit color="#03178C" />
                </IconButton>
              </Tooltip>
            )}
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

TablaUsuarios.propTypes = {
  getUsuarios: PropTypes.func.isRequired,
  eliminarUsuario: PropTypes.func.isRequired,
  editarUsuario: PropTypes.func.isRequired,
  editPassword: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  UI: PropTypes.object.isRequired,
  clienteId: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({
  user: state.user,
  data: state.data,
  UI: state.UI
});

const mapActionsToProps = { getUsuarios, eliminarUsuario, editarUsuario, clearErrors, editPassword };

export default connect(mapStateToProps, mapActionsToProps)(TablaUsuarios);